import React from 'react';

import Table from '../../components/Table';

import 'dayjs/locale/pt';
import { useSales } from 'hooks/useSales';

function Sales() {
  const {
    sales,
    openProgress,
    exportData,
    columns,
    columnsForExport,
    location,
  } = useSales();

  return (
    <Table
      title={location.state ? `Vendas para ${location.state.name}` : 'Vendas'}
      route="/sales/"
      routeAdd="/sale/"
      columns={columns}
      columnsForExport={columnsForExport}
      data={sales}
      exportData={exportData}
      dataLoaded={openProgress}
    />
  );
}

export default Sales;
